export enum PDxReportType {
    POTransmissionReport = 1,
    UsageReport = 2,
    UserComplianceReport = 3,
    VendorPerformanceReport = 4,
    VersioningReport = 5,
    FormularyReport = 6,
    TransactionReport = 7,
    DiscrepancyReport = 8,
}